export default __webpack_public_path__ + "static/media/rfid.df26e97e.png";